import type { FunctionComponent, ReactNode } from 'react';
import { Checkbox } from '@dr.pogodin/react-utils';

import { DIFICULTIES } from 'utils';

import type { CheckboxGroupPropsT } from '../common';

import '../common.scss';

export const DifficultyLevels: FunctionComponent<CheckboxGroupPropsT> = ({
  setSpecs,
  specs,
}) => {
  const difficultyLevelSet = new Set(specs.difficultyLevels);
  const difficultyLevelCheckboxes: ReactNode[] = [];
  for (const level of DIFICULTIES) {
    const checked = difficultyLevelSet.has(level);
    difficultyLevelCheckboxes.push(
      <Checkbox
        checked={checked}
        key={level}
        label={level}
        onChange={() => {
          setSpecs({
            ...specs,
            difficultyLevels: checked
              ? specs.difficultyLevels.filter((item) => item !== level)
              : [...specs.difficultyLevels, level],
          });
        }}
      />,
    );
  }

  return (
    <div styleName="checkboxGroup">
      <div styleName="checkboxGroupTitle">Target Difficulty Levels</div>
      {difficultyLevelCheckboxes}
    </div>
  );
};
